import React from 'react';
import { Typography } from 'src/components/PulseUI';

const NewVolumeHeader = (props) => {
  return (
    <div className="flex items-center px-2 w-full overflow-hidden">
      <Typography
        variant="body2"
        bold
        truncate
        className="w-full"
      >
        {props?.colDef?.headerName}
      </Typography>
    </div>
  );
};

export default NewVolumeHeader;
